import { useState } from 'react';

const useForm = (options) => {
    const [data, setData] = useState((options?.initialValues || {}));
    const [errors, setErrors] = useState({});
    const handleValidations = (_cases, _key, _validation, _value, _valid, _newErrors, _data) => {
        if (_validation?.required?.value && !_value && (_cases==='all' || _cases==='required')) {
            _valid = false;
            _newErrors[_key] = _validation?.required?.message;
        }

        const pattern = _validation?.pattern;
        if (pattern?.value && !RegExp(pattern.value).test(_value) && (_cases==='all' || _cases==='pattern')) {
            _valid = false;
            _newErrors[_key] = pattern.message;
        }

        const match = _validation?.match;
        if (match?.value && typeof _data[match.value] !== 'undefined' && _data[match.value] !== _value && (_cases==='all' || _cases==='match')) {
            _valid = false;
            _newErrors[_key] = match.message;
        }

        const custom = _validation?.custom;
        if (custom?.isValid && !custom.isValid(_value) && (_cases==='all' || _cases==='custom')) {
            _valid = false;
            _newErrors[_key] = custom.message;
        }

        return {
            valid: _valid, 
            newErrors: _newErrors
        }
    }
    const handleChange = (key, sanitizeFn, sanitizeValid) => (e) => {
        const elType = e.target.getAttribute("type") ? e.target.getAttribute("type") : '';
        let value = sanitizeFn ? sanitizeFn(e.target.value) : e.target.value;
        let valueValid = sanitizeValid ? sanitizeValid(value) : value;
        if(elType.toLowerCase()==="checkbox") value = e.target.checked;

        const validations = options?.validations;
        if(typeof validations[key] !== 'undefined' && validations[key].keyup){
            const newErrors = [];
            const keyUpEvent = validations[key].keyup;
            if(keyUpEvent.reuse){
                const response = handleValidations(keyUpEvent.reuse, key, validations[key], valueValid, true, {}, data);
                if(typeof response.newErrors[key] !== "undefined" && !response.valid) newErrors.push(response.newErrors[key]);
            }else{
                keyUpEvent.rules.map(valid => {
                    const validation = {};
                    validation[valid.keyref] = valid;
                    const response = handleValidations(valid.keyref, key, validation, valueValid, true, {}, data);
                    if(typeof response.newErrors[key] !== "undefined" && !response.valid)
                        newErrors.push(response.newErrors[key]);
                    else if(response.valid && valid.showForce)
                        newErrors.push(valid.message.replace('icon-checkmark', 'icon-checkmark icon-ok'));
                });
            }
            errors[key] = keyUpEvent.isHtml && newErrors.length>0 ? { html: newErrors.join("") } : newErrors.join("");
            setErrors(errors);
        }
        setData({
            ...data,
            [key]: value,
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const validations = options?.validations;
        if (validations) {
            let valid = true;
            let newErrors = {};
            for (const key in validations) {
                const value = data[key];
                const validation = validations[key];
                const response = handleValidations('all', key, validation, value, valid, newErrors, data);
                valid = response.valid;
                newErrors = response.newErrors;
            }

            if (!valid) {
                setErrors(newErrors);
                return;
            }
        }

        setErrors({});

        if (options?.onSubmit) {
            options.onSubmit(data);
        }
    }
    const clearForm = (afterClear = null) => {
        setData(options?.initialValues || {});
        afterClear && afterClear();
    }

    return {
        data,
        handleChange,
        handleSubmit,
        clearForm,
        errors
    }
};

export default useForm;